import React from 'react';
import './Footer.css';

export function Footer() {
    return (
        <footer id="Footer">
            <div className="row">
                <div className="column" >
                    <p id="Copyright" >
                        <small>All rights reserved <a href='https://reinz.co.nz/' style={{ color: "white" }}>
                            REINZ
                        </a> &copy; {new Date().getFullYear()} Copyright
                        </small>
                    </p>
                </div>
            </div>
        </footer>
    );

}